import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteExpenseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteExpense = createAsyncThunk('deleteExpense', async (payload) => {
  return await deleteExpenseApi(payload);
});

const deleteExpenseSlice = createSlice({
  name: 'deleteExpense', // Unique Name
  initialState,
  reducers: {
    deleteExpenseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteExpense.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteExpense.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteExpense.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteExpenseReset } = deleteExpenseSlice.actions;

export default deleteExpenseSlice.reducer;
